export default {
  DEPOSIT: 'deposit'
};
